/**
 * Customer Static Objects API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SelectFetchPathsModel = 'SKILLS' | 'GRADES' | 'CERTIFICATES' | 'TITLE_DOMAINS' | 'COMPETENCE_DOMAINS' | 'COMPETENCE_DOMAINS_FILTERED' | 'CONSULTANTS' | 'DELIVERABLES' | 'OFFERINGS';

export const SelectFetchPathsModel = {
    Skills: 'SKILLS' as SelectFetchPathsModel,
    Grades: 'GRADES' as SelectFetchPathsModel,
    Certificates: 'CERTIFICATES' as SelectFetchPathsModel,
    TitleDomains: 'TITLE_DOMAINS' as SelectFetchPathsModel,
    CompetenceDomains: 'COMPETENCE_DOMAINS' as SelectFetchPathsModel,
    CompetenceDomainsFiltered: 'COMPETENCE_DOMAINS_FILTERED' as SelectFetchPathsModel,
    Consultants: 'CONSULTANTS' as SelectFetchPathsModel,
    Deliverables: 'DELIVERABLES' as SelectFetchPathsModel,
    Offerings: 'OFFERINGS' as SelectFetchPathsModel
};

